// Chave do item do carrinho por projeto + produto de doação (AUC-156/157).
// O id do CartItem não serve: o item nasce com id 0 no navegador e ganha o id do servidor
// depois, então o mesmo item aparecia com dois ids entre cartItems e itemsToCheckout.
export function checkoutItemKey(item) {
  if (!item) return "";
  const projectId = item.projectId || (item.project && item.project.id) || 0;
  const donationProductId = item.donationProductId || (item.donationProduct && item.donationProduct.id) || 0;
  return `${projectId}-${donationProductId}`;
}
